module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vk-modal', {
    attrs: {
      "show": _vm.modalShow
    },
    on: {
      "clickOut": function($event) {
        _vm.$emit('close')
      },
      "inactive": function($event) {
        _vm.$emit('close')
      },
      "keyEsc": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('a', {
    staticClass: "uk-close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', [_vm._v(" " + _vm._s(this.modalHeader))])]), _vm._v(" "), _vm._t("modalContent"), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-d",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Peruuta")]), _vm._v(" "), _c('a', {
    staticClass: "btn pull-right btn-lime-green",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('submit'), _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.modalConfirm))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5434d48f"}!./src/app/components/modal/modal.html
// module id = 481
// module chunks = 1